import Stories from './Stories';
export default Stories;